import {Controller, useFieldArray} from "react-hook-form";
import {Control, UseFormRegister} from "react-hook-form/dist/types/form";
import {Grid, Stack} from "@mui/material";
import TextField from "@mui/material/TextField";
import {RemoveCircleOutlineOutlined, ControlPointOutlined} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import {FormLabel, MenuItem} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {PermIdentityOutlined, PhoneOutlined, AlternateEmailOutlined, WorkOutlineOutlined} from "@mui/icons-material";
import {WriteCustomerForm} from "./WriteCustomer";
import {useAllDict} from "@/store/dict.c";
import {TitleBar} from "@/widget/TitleBar/TitleBar";
import React from "react";
import {DictPO} from "@/model/system";

interface ContactFormProps {
    control: Control<WriteCustomerForm>;
    register: UseFormRegister<WriteCustomerForm>;
    errors: FieldErrors<WriteCustomerForm>;
    firstedErrMsg: string
}

const ContactForm = ({control, register, errors, firstedErrMsg}: ContactFormProps) => {
    const {fields, append, remove} = useFieldArray({
        name: "contacts",
        control,
        keyName: "_id"
    });
    const {boole, gender} = useAllDict()

    return (
        <>
            <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignContent={"center"}
                alignItems={'center'}
            >
                <TitleBar title={"联系人"} extra={<IconButton
                    size={"small"}
                    onClick={() => append({name: "", mobile: "", firsted: 0, gender: 0, post: ''})}
                    color={'default'}
                    sx={{padding: 0}}>
                    <ControlPointOutlined/>
                </IconButton>}/>
            </Stack>
            {fields.map((field, index) => {
                return (
                    <Stack
                        key={field._id}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        alignContent={"center"}
                        width={'100%'}
                    >
                        <Grid spacing={2} container>
                            <Grid size={6}>
                                <FormControl fullWidth={true} required={true}>
                                    <FormLabel>姓名</FormLabel>
                                    <TextField
                                        error={!!errors?.contacts?.[index]?.name}
                                        helperText={errors?.contacts?.[index]?.name?.message}
                                        {...register(`contacts.${index}.name`)}
                                        slotProps={{
                                            input: {
                                                inputProps: {maxLength: 10},
                                                endAdornment: (
                                                    <PermIdentityOutlined color="disabled"/>
                                                ),
                                            },
                                        }}
                                        placeholder="填写姓名"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid size={6}>
                                <FormControl fullWidth={true} required={true}>
                                    <FormLabel>联系电话</FormLabel>
                                    <TextField
                                        error={!!errors?.contacts?.[index]?.mobile}
                                        helperText={errors?.contacts?.[index]?.mobile?.message}
                                        {...register(`contacts.${index}.mobile`)}
                                        slotProps={{
                                            input: {
                                                inputProps: {maxLength: 15},
                                                endAdornment: (
                                                    <PhoneOutlined color="disabled"/>
                                                ),
                                            },
                                        }}
                                        placeholder="填写联系电话"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid size={6}>
                                <FormControl fullWidth={true}>
                                    <FormLabel>首要联系人</FormLabel>
                                    <Controller control={control} render={({field: {onChange, value}}) => {
                                        return <TextField error={!!firstedErrMsg} helperText={firstedErrMsg} value={value} onChange={event => onChange(event.target.value)}
                                                          placeholder={"选择首要联系人"} select={true}>
                                            {boole?.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    }} name={`contacts.${index}.firsted`}/>
                                </FormControl>
                            </Grid>

                            <Grid size={6}>
                                <FormControl fullWidth={true}>
                                    <FormLabel>性别</FormLabel>
                                    <Controller control={control} render={({field: {onChange, value}}) => {
                                        return <TextField value={value} onChange={event => onChange(event.target.value)}
                                                          placeholder={"选择性别"} select={true}>
                                            {gender?.map((option: DictPO, index: number) => (
                                                <MenuItem key={index} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    }} name={`contacts.${index}.gender`}/>
                                </FormControl>
                            </Grid>
                            {/*<Grid size={6}>*/}
                            {/*    <FormControl fullWidth={true}>*/}
                            {/*        <FormLabel>性别</FormLabel>*/}
                            {/*        <TextField  {...register(`contacts.${index}.gender`)}*/}
                            {/*                    placeholder={"选择性别"} select={true}>*/}
                            {/*            {gender?.map((option) => (*/}
                            {/*                <MenuItem key={option.value} value={option.value}>*/}
                            {/*                    {option.label}*/}
                            {/*                </MenuItem>*/}
                            {/*            ))}*/}
                            {/*        </TextField>*/}
                            {/*    </FormControl>*/}
                            {/*</Grid>*/}
                            <Grid size={6}>
                                <FormControl fullWidth={true}>
                                    <FormLabel htmlFor="email">联系邮箱</FormLabel>
                                    <TextField
                                        id="email"
                                        {...register(`contacts.${index}.email`)}
                                        error={!!errors?.contacts?.[index]?.email}
                                        helperText={errors?.contacts?.[index]?.email?.message}
                                        slotProps={{
                                            input: {
                                                inputProps: {maxLength: 60},
                                                endAdornment: (
                                                    <AlternateEmailOutlined color="disabled"/>
                                                ),
                                            },
                                        }}
                                        placeholder="填写联系邮箱"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid size={6}>
                                <FormControl fullWidth={true}>
                                    <FormLabel htmlFor="post">职位</FormLabel>
                                    <TextField
                                        id="post"
                                        {...register(`contacts.${index}.post`)}
                                        slotProps={{
                                            input: {
                                                inputProps: {maxLength: 20},
                                                endAdornment: (
                                                    <WorkOutlineOutlined color="disabled"/>
                                                ),
                                            },
                                        }}
                                        placeholder="填写职位"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        {fields?.length > 1 ? (
                            <IconButton
                                onClick={() => remove(index)}
                                sx={{padding: 0}}
                                size={"small"}
                            >
                                <RemoveCircleOutlineOutlined color={"error"}/>
                            </IconButton>
                        ) : <></>}
                    </Stack>
                );
            })}
        </>
    );
};

export default ContactForm;
